export enum CustomerType {
  Private = "Private",
  Business = "Business",
}
